/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ModeratorProductFeedback,
  ModeratorProductFeedbackApproveRequest,
  ModeratorProductFeedbackCommentRequest,
  ModeratorsProductFeedbackListParams,
  ModeratorsProductFeedbackUnverifiedHsCodesRetrieveParams,
  PaginatedModeratorProductFeedback,
  PaginatedModeratorUnverifiedHsCodeProduct,
  PatchedModeratorProductFeedbackCommentRequest
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * List all user-submitted product/HS code feedbacks. Filter by status: pending (not reviewed yet), approved, rejected. Paginated.
 * @summary List product HS code feedbacks
 */
export const moderatorsProductFeedbackList = (
    params?: ModeratorsProductFeedbackListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedModeratorProductFeedback[]>(
      {url: `/api/v1/moderators/product-feedback/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsProductFeedbackListQueryKey = (params?: ModeratorsProductFeedbackListParams,) => {
    return [`/api/v1/moderators/product-feedback/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsProductFeedbackListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsProductFeedbackList>>, TError = unknown>(params?: ModeratorsProductFeedbackListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsProductFeedbackListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsProductFeedbackList>>> = ({ signal }) => moderatorsProductFeedbackList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsProductFeedbackListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsProductFeedbackList>>>
export type ModeratorsProductFeedbackListQueryError = unknown

/**
 * @summary List product HS code feedbacks
 */
export const useModeratorsProductFeedbackList = <TData = Awaited<ReturnType<typeof moderatorsProductFeedbackList>>, TError = unknown>(
 params?: ModeratorsProductFeedbackListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsProductFeedbackListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Moderator/Super moderator: list product HS code feedbacks, add comment, approve or reject.
 * @summary Get product feedback detail
 */
export const moderatorsProductFeedbackRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ModeratorProductFeedback>(
      {url: `/api/v1/moderators/product-feedback/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsProductFeedbackRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/moderators/product-feedback/${id}/`] as const;
    }

    
export const getModeratorsProductFeedbackRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsProductFeedbackRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsProductFeedbackRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsProductFeedbackRetrieve>>> = ({ signal }) => moderatorsProductFeedbackRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsProductFeedbackRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsProductFeedbackRetrieve>>>
export type ModeratorsProductFeedbackRetrieveQueryError = void

/**
 * @summary Get product feedback detail
 */
export const useModeratorsProductFeedbackRetrieve = <TData = Awaited<ReturnType<typeof moderatorsProductFeedbackRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsProductFeedbackRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Set status to approved, save corrected product name and HS code. If productId is provided, that product's name and hsCode are updated; the product must belong to the company that reported the feedback (400 otherwise, 404 if it does not exist). Nothing is written on refusal.
 * @summary Approve feedback
 */
export const moderatorsProductFeedbackApproveCreate = (
    id: number,
    moderatorProductFeedbackApproveRequest: ModeratorProductFeedbackApproveRequest,
 ) => {
      
      
      return customInstance<ModeratorProductFeedback>(
      {url: `/api/v1/moderators/product-feedback/${id}/approve/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: moderatorProductFeedbackApproveRequest
    },
      );
    }
  


export const getModeratorsProductFeedbackApproveCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackApproveCreate>>, TError,{id: number;data: ModeratorProductFeedbackApproveRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackApproveCreate>>, TError,{id: number;data: ModeratorProductFeedbackApproveRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsProductFeedbackApproveCreate>>, {id: number;data: ModeratorProductFeedbackApproveRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsProductFeedbackApproveCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsProductFeedbackApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsProductFeedbackApproveCreate>>>
    export type ModeratorsProductFeedbackApproveCreateMutationBody = ModeratorProductFeedbackApproveRequest
    export type ModeratorsProductFeedbackApproveCreateMutationError = void

    /**
 * @summary Approve feedback
 */
export const useModeratorsProductFeedbackApproveCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackApproveCreate>>, TError,{id: number;data: ModeratorProductFeedbackApproveRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsProductFeedbackApproveCreate>>,
        TError,
        {id: number;data: ModeratorProductFeedbackApproveRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsProductFeedbackApproveCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Moderator/Super moderator: list product HS code feedbacks, add comment, approve or reject.
 * @summary Add moderator comment
 */
export const moderatorsProductFeedbackCommentUpdate = (
    id: number,
    moderatorProductFeedbackCommentRequest: ModeratorProductFeedbackCommentRequest,
 ) => {
      
      
      return customInstance<ModeratorProductFeedback>(
      {url: `/api/v1/moderators/product-feedback/${id}/comment/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: moderatorProductFeedbackCommentRequest
    },
      );
    }
  


export const getModeratorsProductFeedbackCommentUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackCommentUpdate>>, TError,{id: number;data: ModeratorProductFeedbackCommentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackCommentUpdate>>, TError,{id: number;data: ModeratorProductFeedbackCommentRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsProductFeedbackCommentUpdate>>, {id: number;data: ModeratorProductFeedbackCommentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsProductFeedbackCommentUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsProductFeedbackCommentUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsProductFeedbackCommentUpdate>>>
    export type ModeratorsProductFeedbackCommentUpdateMutationBody = ModeratorProductFeedbackCommentRequest
    export type ModeratorsProductFeedbackCommentUpdateMutationError = void

    /**
 * @summary Add moderator comment
 */
export const useModeratorsProductFeedbackCommentUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackCommentUpdate>>, TError,{id: number;data: ModeratorProductFeedbackCommentRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsProductFeedbackCommentUpdate>>,
        TError,
        {id: number;data: ModeratorProductFeedbackCommentRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsProductFeedbackCommentUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Moderator/Super moderator: list product HS code feedbacks, add comment, approve or reject.
 * @summary Add moderator comment
 */
export const moderatorsProductFeedbackCommentPartialUpdate = (
    id: number,
    patchedModeratorProductFeedbackCommentRequest: PatchedModeratorProductFeedbackCommentRequest,
 ) => {
      
      
      return customInstance<ModeratorProductFeedback>(
      {url: `/api/v1/moderators/product-feedback/${id}/comment/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedModeratorProductFeedbackCommentRequest
    },
      );
    }
  


export const getModeratorsProductFeedbackCommentPartialUpdateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackCommentPartialUpdate>>, TError,{id: number;data: PatchedModeratorProductFeedbackCommentRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackCommentPartialUpdate>>, TError,{id: number;data: PatchedModeratorProductFeedbackCommentRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsProductFeedbackCommentPartialUpdate>>, {id: number;data: PatchedModeratorProductFeedbackCommentRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsProductFeedbackCommentPartialUpdate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsProductFeedbackCommentPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsProductFeedbackCommentPartialUpdate>>>
    export type ModeratorsProductFeedbackCommentPartialUpdateMutationBody = PatchedModeratorProductFeedbackCommentRequest
    export type ModeratorsProductFeedbackCommentPartialUpdateMutationError = void

    /**
 * @summary Add moderator comment
 */
export const useModeratorsProductFeedbackCommentPartialUpdate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackCommentPartialUpdate>>, TError,{id: number;data: PatchedModeratorProductFeedbackCommentRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsProductFeedbackCommentPartialUpdate>>,
        TError,
        {id: number;data: PatchedModeratorProductFeedbackCommentRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsProductFeedbackCommentPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Moderator/Super moderator: list product HS code feedbacks, add comment, approve or reject.
 * @summary Reject feedback
 */
export const moderatorsProductFeedbackRejectCreate = (
    id: number,
 ) => {
      
      
      return customInstance<ModeratorProductFeedback>(
      {url: `/api/v1/moderators/product-feedback/${id}/reject/`, method: 'POST'
    },
      );
    }
  


export const getModeratorsProductFeedbackRejectCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackRejectCreate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackRejectCreate>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsProductFeedbackRejectCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  moderatorsProductFeedbackRejectCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsProductFeedbackRejectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsProductFeedbackRejectCreate>>>
    
    export type ModeratorsProductFeedbackRejectCreateMutationError = void

    /**
 * @summary Reject feedback
 */
export const useModeratorsProductFeedbackRejectCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackRejectCreate>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsProductFeedbackRejectCreate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getModeratorsProductFeedbackRejectCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * OQ-05: products whose HS code isn't in the official HS table. They are accepted (warn, but allow) and flagged here for review; the matching engine gives them no HS-alignment credit. Paginated.
 * @summary List products with unverified HS codes
 */
export const moderatorsProductFeedbackUnverifiedHsCodesRetrieve = (
    params?: ModeratorsProductFeedbackUnverifiedHsCodesRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedModeratorUnverifiedHsCodeProduct>(
      {url: `/api/v1/moderators/product-feedback/unverifiedHsCodes/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsProductFeedbackUnverifiedHsCodesRetrieveQueryKey = (params?: ModeratorsProductFeedbackUnverifiedHsCodesRetrieveParams,) => {
    return [`/api/v1/moderators/product-feedback/unverifiedHsCodes/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsProductFeedbackUnverifiedHsCodesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsProductFeedbackUnverifiedHsCodesRetrieve>>, TError = unknown>(params?: ModeratorsProductFeedbackUnverifiedHsCodesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackUnverifiedHsCodesRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsProductFeedbackUnverifiedHsCodesRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsProductFeedbackUnverifiedHsCodesRetrieve>>> = ({ signal }) => moderatorsProductFeedbackUnverifiedHsCodesRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackUnverifiedHsCodesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsProductFeedbackUnverifiedHsCodesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsProductFeedbackUnverifiedHsCodesRetrieve>>>
export type ModeratorsProductFeedbackUnverifiedHsCodesRetrieveQueryError = unknown

/**
 * @summary List products with unverified HS codes
 */
export const useModeratorsProductFeedbackUnverifiedHsCodesRetrieve = <TData = Awaited<ReturnType<typeof moderatorsProductFeedbackUnverifiedHsCodesRetrieve>>, TError = unknown>(
 params?: ModeratorsProductFeedbackUnverifiedHsCodesRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsProductFeedbackUnverifiedHsCodesRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsProductFeedbackUnverifiedHsCodesRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



